import { useCallback } from "react";
import { Modal } from "antd";
import { useLocation } from "react-router-dom";

export function useDirtyNavigationGuard(navigate) {
    const location = useLocation();

    const getIsDirty = useCallback(() => {
        if (location.pathname.includes("/flightSchedule/editor")) {
            return window.scheduleDirtyState || false;
        }

        return false;
    }, [location.pathname]);

    const safeNavigate = useCallback(
        (path) => {
            const isDirty = getIsDirty();

            if (isDirty) {
                if (window.scheduleEditorNavigate) {
                    window.scheduleEditorNavigate(path);
                    return;
                }

                Modal.confirm({
                    title: "未保存提醒",
                    content: "您有未保存的更改，确定要离开吗？",
                    okText: "确认离开",
                    cancelText: "取消",
                    onOk: () => {
                        navigate(path);
                    },
                });
                return;
            }

            navigate(path);
        },
        [getIsDirty, navigate],
    );

    return { safeNavigate };
}
